import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { DataService } from '../../shared/services/data.service';
import { TncConstantsService } from './tnc-constants.service';

@Injectable()
export class TrainingAndCompetencyService {

  public currentTNCPageIndex: number;
  public updateSourceActionData: any;
  public oldTNCTrainingStatus: any;
  public oldTNCApprovalDetails: any;
  constructor(private dataService: DataService, private baseService: BaseService) { }

  getAllTnCRequestIds() {
    return JSON.parse(this.baseService.getItemFromSession('TnCIds'));
  }
  public setAllTnCRequestIds(allTnCData) {
    
    let TnCIds = [];
    allTnCData.forEach(item => {
      TnCIds.push({ 'CourseId': item.CourseId, 'UnitId': item.UnitId });
    });
    this.baseService.setItemInSession('TnCIds', JSON.stringify(TnCIds));
  }
  public getSourceActionData() {
    return this.updateSourceActionData;
  }
  public setSourceActionData(data) {
    this.updateSourceActionData = data;
  }

  public getTNCTrainingStatus() {
    return ((this.oldTNCTrainingStatus != undefined && this.oldTNCTrainingStatus != null) ? this.oldTNCTrainingStatus : "") ;
  }
  public setTNCTrainingStatus(data) {
    this.oldTNCTrainingStatus = data;
  }

  public getTNCApprovalDetails() {
    return this.oldTNCApprovalDetails;
  }
  public setTNCApprovalDetails(data) {
    this.oldTNCApprovalDetails = data;
  }
  
  

  getTNCRequests(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.RoutingURLConstant.GetTnCRequests, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTNCUserProfiles(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.RoutingURLConstant.GetTnCUserProfiles, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTrainingStatus(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.RoutingURLConstant.GetTnCStatus, model).subscribe(
      response => callbackMethod(response)
    );
  }
  public setcurrentTNCPageIndex(pageId) {
    this.currentTNCPageIndex = pageId;
  }

  getPTWRequests(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.TNCGetURL.GetTnCRequests, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTnCParticulars(model, callbackMethod){
    this.dataService
    .post(
        TncConstantsService.TNCGetURL.GetTnCParticulars,
      model
    )
    .subscribe((response) => {
      callbackMethod(response);
    });

  }

  getTnCConfiguration(model, callbackMethod){
    this.dataService
    .post(
        TncConstantsService.TNCGetURL.GetTnCConfiguration,
      model
    )
    .subscribe((response) => {
      callbackMethod(response);
    });
  }

  saveTnCRequest(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.TNCGetURL.SaveTnCRequest, model).subscribe(
      response => callbackMethod(response)
    );
  }

  checkDuplicateTraining(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.TNCGetURL.checkDuplicateTraining, model).subscribe(
      response => callbackMethod(response)
    );
  }

  saveTnCStatus(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.TNCGetURL.SaveTnCStatus, model).subscribe(
      response => callbackMethod(response)
    );
  }
  saveTnCApprovals(model, callbackMethod) {
    return this.dataService.post(TncConstantsService.TNCGetURL.SaveTnCApprovals, model).subscribe(
      response => callbackMethod(response)
    );
  }

  getTNCRequestByCourseId(model,callbackMethod){
    return this.dataService.post(TncConstantsService.TNCGetURL.GetCourseByCourseId,model).subscribe(
      response => callbackMethod(response)
    );
  }

  getReportiesByManagerId(model,callbackMethod){
    return this.dataService.post(TncConstantsService.TNCGetURL.getReportiesByManagerId,model).subscribe(
      response => callbackMethod(response)
    );
  }

  setCourseReschedule(model,callbackMethod){
    return this.dataService.post(TncConstantsService.TNCGetURL.SetCourseReschedule,model).subscribe(
      response => callbackMethod(response)
    );
  }

  setcurrentCourseRequestId(pageId){
  this.currentTNCPageIndex = pageId;
  }

  getAllTnCIds(){
  return JSON.parse(this.baseService.getItemFromSession('TnCIds'));
  }

  downloadPDF(model, callbackMethod) {
    this.dataService.postHttpResponse("api/tnc/get/downloadpdf", model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  downloadUserProfilePDF(model, callbackMethod) {
    this.dataService.postHttpResponse(TncConstantsService.TNCGetURL.DownloadUserProfilePDF, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  exportToExcelTnCCourses(model, callbackMethod) {
    this.dataService.post(TncConstantsService.TNCGetURL.ExportToExcelTnCCourses, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  exportToTrainingMatrixExcel(model, callbackMethod) {
    this.dataService.postHttpResponse(TncConstantsService.TNCGetURL.ExportToTrainingMatrixExcel, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  downloadZIP(model, callbackMethod) {
    this.dataService.postHttpResponse(TncConstantsService.TNCGetURL.DownloadZip, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }

  saveTNCParticulars(model,callbackMethod){
    return this.dataService.post(TncConstantsService.TNCGetURL.SaveTNCParticulars,model).subscribe(
      response => callbackMethod(response)
    );
  }
  updateTnCReminderNotification(model, callbackMethod) {
    this.dataService.postHttpResponse("api/tnc/post/updateTnCReminderNotification", model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}
